import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const API_BASE_URL = 'https://us-central1-mariokarts-fee04.cloudfunctions.net/api';

const CarSwiper = () => {
    const [soldCars, setSoldCars] = useState([]);

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/cars`)
            .then(response => response.json())
            .then(data => {
                const sold = data
                    .filter(car => car.isSold && car.soldDate) // Ensure they are sold and have a soldDate
                    .sort((a, b) => new Date(b.soldDate) - new Date(a.soldDate)) // Sort by most recent soldDate
                    .slice(0, 6); // Get the top 6
                setSoldCars(sold);
            })
            .catch(error => console.error('Error fetching sold cars:', error));
    }, []);

    if (soldCars.length === 0) {
        return null;
    }

    return (
        <section className="popular section" id="popular">
            <div className="popular__container container swiper">
                <h2 className="section__title">
                    Últimos coches vendidos <br/> en Manna Cars
                </h2>
                <Swiper
                    modules={[Pagination]}
                    spaceBetween={30}
                    loop={soldCars.length > 1}
                    slidesPerView={1} // Start with 1 on mobile
                    centeredSlides={true}
                    pagination={{ clickable: true }}
                    className="home-swiper"
                    breakpoints={{
                        640: {
                            slidesPerView: 1.5,
                            spaceBetween: 20,
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3.5,
                            centeredSlides: true,
                            spaceBetween: 20,
                        },
                    }}
                >
                    {soldCars.map(car => (
                        <SwiperSlide key={car.id}>
                            <div className="car-card-wrapper">
                                <div className="card car-card">
                                    {car.isSold && <div className="sold-banner">Vendido</div>}
                                    <img src={car.image} className="card-img-top" alt={`${car.brand} ${car.model}`} />
                                    <div className="card-body d-flex flex-column">
                                        <h5 className="card-title">{car.brand} {car.model}</h5>
                                        <p className="card-text" style={{fontSize: '.8rem', opacity: 0.8}}>{car.year} - {car.km} km</p>
                                        <h4 className="featured__price mt-auto mb-0">€{car.price}</h4>
                                        <hr style={{borderColor: '#374a6d40'}}/>
                                        <Link to={`/coche/${car.id}`} className="btn btn-orange w-100">Ver detalles</Link>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    );
}

export default CarSwiper;
